/**
 * Keeps retail custom-vivarium cart totals correct after BSS B2B scripts run.
 * BSS targets [bss-b2b-cart-total-price]; vivarium totals use [data-vivarium-cart-total] instead.
 */
(function () {
  const VIVARIUM_TOTAL_SELECTOR = '[data-vivarium-cart-total]';

  function restoreVivariumCartTotals() {
    document.querySelectorAll(VIVARIUM_TOTAL_SELECTOR).forEach((el) => {
      const expected = el.dataset.vivariumTotalHtml;
      if (!expected) return;

      const current = el.innerHTML.trim();
      const target = expected.trim();
      if (current !== target) {
        el.innerHTML = expected;
      }
    });
  }

  function observeVivariumCartTotals() {
    document.querySelectorAll(VIVARIUM_TOTAL_SELECTOR).forEach((el) => {
      if (el.__vivariumTotalObserver) return;

      const expected = el.dataset.vivariumTotalHtml;
      if (!expected) return;

      const observer = new MutationObserver(() => {
        if (el.innerHTML.trim() !== expected.trim()) {
          el.innerHTML = expected;
        }
      });

      observer.observe(el, { childList: true, characterData: true, subtree: true });
      el.__vivariumTotalObserver = observer;
    });
  }

  function init() {
    restoreVivariumCartTotals();
    observeVivariumCartTotals();

    [100, 500, 1500, 3000].forEach((ms) => {
      setTimeout(restoreVivariumCartTotals, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(init, 100);
    });
  }
})();
